<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="level">
      <div class="level-left">
        <h1 class="title is-5">{{ $t('docflow.docTypes.appeals') }}</h1>
      </div>
      <div class="level-right" v-if="isDocflowAppealManager || isSuperUser">
        <div class="field is-grouped controls">
          <button @click="$router.push({name: 'createAppealDocflow'})"
                  class="button is-success">
            {{ $t('docflow.newDocument') }}
          </button>
        </div>
      </div>
    </div>
    <div class="container is-fluid">
      <AppealsList :data="data"
                   :loading="loading"
                   :total="total"
                   :per-page="perPage"
                   :sort-field="sortField"
                   :sort-order="sortOrder"
                   @search="loadData"
                   @filter="loadData"
                   @page-change="onPageChange"
                   @sort="onSort"
                   @reset-filters="loadData">
      </AppealsList>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import DashboardLayout from '@/components/DashboardLayout'
  import AppealsList from '@/components/AppealsList'
  import OutgoingList from '@/components/OutgoingList'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'
  import {deleteObjectKeysByValue} from '@/utils'

  export default {
    components: {
      DashboardLayout,
      GovernmentAgencySelect,
      AppealsList,
      OutgoingList
    },
    data() {
      return {
        data: [],
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        category: 'appeals',
        filters: {}
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.$store.dispatch('Docflow/list', {
          category: this.category,
          page: this.page,
          page_size: this.perPage,
          q: this.q,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`,
          ...this.prepareFilter('appealFilters')
        }).then((data) => {
          this.loading = false
          this.total = data.count
          this.data = data.results
        })
      },
      onSort({field, order}) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      }
    },
    mounted() {
      this.page = this.appealFilters.page
      this.loadData()
    },
    computed: {
      ...mapState('Docflow', ['list']),
      ...mapState('Filters', ['appealFilters']),
      ...mapGetters('Account', ['isDocflowAppealManager', 'isSuperUser']),
      ...mapGetters('Filters', ['prepareFilter']),
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowAppeals'}
        ]
      }
    }
  }
</script>
